import { useMutation } from "@tanstack/react-query";
import { accountMigration } from "@src/entities/login/api/requests/accountMigration";
import { useAuthStore } from "../../store/authStore";

export const useAccountMigration = () => {
  const query = useMutation({
    mutationFn: accountMigration,
    onSuccess: (response) => {
      useAuthStore.getState().setUser({
        user: response.data.user,
        tokens: {
          access_token: response.data.tokens.access,
        },
      });
    },
  });
  return query;
};
